import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import Quill from 'quill';
import { redoSvg, undoSvg } from './icons';

@Component({
  selector: 'gymfinder-html-editor',
  templateUrl: './html-editor.component.html',
  styleUrls: ['./html-editor.component.scss'],
  standalone: false,
})
export class HtmlEditorComponent implements OnInit {
  @Input()
  disabled = false;

  @Input()
  data: string | undefined;

  @Input()
  maxChars: number | undefined;

  @Input()
  height = 300;

  @Output()
  dataChange = new EventEmitter<string | undefined>();

  @ViewChild('editor') editor: QuillEditorComponent;

  charCount = 0;

  editorModules = {
    toolbar: {
      container: [
        ['undo', 'redo'],
        [{ header: 3 }, { header: 4 }],
        ['bold', 'italic'],
        ['link'],
        [{ align: [] }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ list: 'bullet' }, { list: 'ordered' }],
      ],
      handlers: {
        undo: () => this.undo(),
        redo: () => this.redo(),
      },
    },
    history: {
      delay: 1000,
      maxStack: 100,
      userOnly: false,
    },
  };

  ngOnInit(): void {
    const icons = Quill.import('ui/icons') as any;
    icons['undo'] = undoSvg;
    icons['redo'] = redoSvg;
  }

  onModelChange(newValue: string) {
    this.data = newValue;
    this.dataChange.emit(newValue);
    this.calculateCharCount();
  }

  calculateCharCount() {
    const text = this.editor?.quillEditor.getText() || '';
    this.charCount = text.endsWith('\n') ? text.length - 1 : text.length;
  }

  undo() {
    this.editor?.quillEditor.history.undo();
  }

  redo() {
    this.editor?.quillEditor.history.redo();
  }

  onEditorCreated() {
    this.calculateCharCount();
  }

  getEditorStyles() {
    return {
      height: `${this.height}px`,
      'font-size': 'initial',
    };
  }
}
